import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { getProductDefaultInfo } from '../../../../utilities/selectors';
import { getZlataPriadkaProductDefaultInfo } from '../../selectors';
import { TableTd, TableRow } from '../../General/Table';
import {
  FlexCol,
  FlexRowCenterHorizontal,
  Flexbox,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { CountSetter } from '../../ProductDetail/CountSetter';
import {
  getImagePath,
  getSymbolFromCurrency,
  round,
} from '../../../../utilities';

export interface Props {
  product: any;
  theme: any;
  count: number;
  handleCountChange: any;
  isLoggedIn: any;
}

function ModalItemsTabRow({ product, theme, count, handleCountChange }: Props) {
  const { currency } = getProductDefaultInfo(product);
  const { unit, price, picture } = getZlataPriadkaProductDefaultInfo(product);

  const step = unit === 'm' ? 0.1 : 1;

  return (
    <>
      <ImageNameTableTd align="right">
        <ImageWrapper>
          <Image
            alt={`Obrázok ku produktu ${product.name}`}
            src={
              picture
                ? getImagePath(
                    process.env.REACT_APP_API_BASE_URL as string,
                    picture,
                    { width: 80, height: 80 },
                  )
                : '/images/zlatapriadka/placeholder.svg'
            }
          />
        </ImageWrapper>
        <NameInputWrapper>
          <Name>{product.name}</Name>
        </NameInputWrapper>
      </ImageNameTableTd>
      <StyledTableTd>
        <CountWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={step}
          />
        </CountWrapper>
      </StyledTableTd>
      <StyledTableTd align="right">
        <Price>{`${round(price * count, 2)} ${getSymbolFromCurrency(
          currency,
        )}`}</Price>
      </StyledTableTd>
    </>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(24)} 0;
`;

const CountWrapper = styled(Flexbox)`
  width: max-content;
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled(Link)`
  margin-right: ${rem(16)};
`;

const Image = styled.img`
  width: ${rem(48)};
  height: ${rem(48)};
  max-width: initial;
  object-fit: contain;
`;

const NameInputWrapper = styled(FlexCol)``;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  text-align: left;
  font-weight: 300;
  white-space: nowrap;
  max-width: ${rem(272)};
  transition: color 0.2s;
  text-overflow: ellipsis;
  overflow: hidden;
}

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `}
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
`;

const WithTheme: any = withTheme(ModalItemsTabRow);
export { WithTheme as ModalItemsTabRow };
